// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__guzaZ","errorCode":"NotFound_errorCode__uLbJg","errorMessage":"NotFound_errorMessage__LpOUr","pulse":"NotFound_pulse__JYNJi"};